import { ConsentComponent } from '../components/consent/consent.component';
import { OptOutComponent } from '../components/opt-out/opt-out.component';
import { ConsentModule } from '../consent.module';
import { Application } from '../framework/application';

export class OptOutApplication extends Application {
  constructor() {
    super('opt-out', {
      declarations: [ConsentComponent, OptOutComponent],
      modules: [ConsentModule],
      tracesSampler: () => 0.1,
    });
  }

  protected async onInit() {}
}
